module.exports = __webpack_public_path__ + "img/schedule2.c95df32b.svg";